exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".WordSuggestions__link___nQ9GB {\n  text-decoration: underline;\n}\n.WordSuggestions__wordGroup___3grD7 {\n  padding: 10px;\n  border: 1px solid #eee;\n  border-radius: 3px;\n  margin-bottom: 15px;\n}\n.WordSuggestions__wordGroupTitle___J0QI1 {\n  margin-bottom: 3px;\n  font-weight: 700;\n}\n", ""]);
// Exports
exports.locals = {
	"link": "WordSuggestions__link___nQ9GB",
	"wordGroup": "WordSuggestions__wordGroup___3grD7",
	"wordGroupTitle": "WordSuggestions__wordGroupTitle___J0QI1"
};